import { Controller } from "@hotwired/stimulus"

// The month-by-month chart: click a bar, or tab to it and press Enter or
// Space, to show that month's detail line. The server renders every line;
// this only chooses which one is visible. The choice survives the Turbo Frame
// re-render after each recalculation, because the frame replaces this element.
let rememberedIndex = null

export default class extends Controller {
  static targets = ["month", "detail"]
  static values = { selected: Number }

  connect() {
    this.show(rememberedIndex ?? this.selectedValue)
  }

  pick(event) {
    this.show(Number(event.currentTarget.dataset.index))
  }

  key(event) {
    if (event.key !== "Enter" && event.key !== " ") return

    event.preventDefault()
    this.pick(event)
  }

  show(index) {
    rememberedIndex = index
    this.monthTargets.forEach((month) => {
      month.setAttribute("aria-pressed", String(Number(month.dataset.index) === index))
    })
    this.detailTargets.forEach((detail) => {
      detail.hidden = Number(detail.dataset.index) !== index
    })
  }
}
